<template>
    <div
        class="PageBuilderImages"
    >
        <flickity
            v-if="images.length > 1"
            ref="flickity"
            :options="flickityOptions"
        >

            <BaseImage
                v-for="(image, index) in images"
                :key="index"
                :placeholder="image.placeholder"
                :srcset="image.srcset"
                :ratio="image.ratio"
                :caption="image.caption"
            />
        </flickity>

        <BaseImage
            v-else
            :placeholder="images[0].placeholder"
            :srcset="images[0].srcset"
            :ratio="images[0].ratio"
        />


        <ul
            v-if="images.length > 1"
            class="PageBuilderImages__nav"
        >
            <ProgressiveCircle
                v-for="n in images.length"
                :key="n"
                :index="n - 1"
                :activeSlide="activeSlide"
                @setActive="setActive"
            />
        </ul>
    </div>
</template>
<script>
import Flickity from './BaseCarousel.vue'

import { carouselProgressiveCircles } from '@mixins/carouselProgressiveCircles.js'

export default {
    name: 'PageBuilderImages',
    mixins: [carouselProgressiveCircles],
    components: {
        Flickity
    },
    props: {
        images: {
            type: Array,
            default: null
        },
        speed: {
            type:[ Boolean, Number ],
            default: true
        }
    },
    data() {
        return {
            flickityOptions: {
                initialIndex: 0,
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true,
                imagesLoaded: true,
                autoPlay: this.speed,
                selectedAttraction: 0.01,
                friction: 0.15
            },
        }
    },
    mounted() {
        if (this.images.length > 1) {
            const carousel = document.querySelector('.PageBuilderImages')
            const flkty = this.$refs.flickity.data(carousel)

            flkty.on('change', () => {
                this.selectActiveSlide(flkty)
            });
        }
    }
}
</script>
<style lang="scss" scoped>
    .BaseImage {
        width: 100%;
    }

    .PageBuilderImages__nav {
        margin-top: getSpacing('spacer');
    }

    .PageBuilderImages--nav-inner {
        position: relative;
    }

    .PageBuilderImages--nav-inner {
        .PageBuilderImages__nav {
            position: absolute;
            bottom: 1.5rem;
            right: 1.5rem;
        }

        ::v-deep .ProgressiveCircle span {
            background: #fff;
            opacity: .5;
        }
        
        ::v-deep .ProgressiveCircle.is-active {
            border: 3px solid white;
            border-radius: 100%;

            span {
                opacity: 1;
                background: #fff;
            }
        }

        .ProgressiveCircle {
            width: 28px;
            height: 28px;
        }
    }


    
</style>
